// additional request headers to be sent to the polygon service

const headers = {};

export const setAdditionalHeader = (name: string, value: string) => {
	headers[name] = value;
};

export const getAdditionalHeaders = () => {
	return { ...headers };
};
